import { EndpointService } from '@ispm/shared/services/endpoint.service';
import { IEndpoint } from '@ispm/shared/interfaces/endpoint.interface';
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export class SetWebEndpointValueInLocalStorage {
  constructor(
    private endpointService: EndpointService
  ) {
  }

  resolve() {
    return this.endpointService.getGenomicsWebEndpoint().toPromise().then((res: IEndpoint) => {
      localStorage.setItem('webEndPoint', res.endpoint);
    });
  }
}
